import React, { useEffect, useState } from "react";
import {
  Card,
  Grid,
  Checkbox,
  FormControlLabel,
  Button,
  Icon,
} from "@mui/material";
import AsyncSelect from "react-select/async";

// Material Dashboard 2 React components
import MDBox from "components/MDBox";
import MDInput from "components/MDInput";
import MDTypography from "components/MDTypography";

// API & Models
import CreateAccountingSessionReq from "../../../../../Classes/Models/Requests/AccountingSessions/CreateAccountingSessionReq";
import UsersApi from "../../../../../Classes/API/UsersApi";
import searchUsersReq from "../../../../../Classes/Models/Requests/Users/SearchUser";
import UserTypes from "../../../../../Classes/Models/Requests/Users/UserTypes";

const SearchSingleSessions = ({ setSearchReq, GetTableData, IsLoaded }) => {
  const [filters, setFilters] = useState({
    id: "",
    isPaidFor: false,
    isException: false,
    noAppointmentOnly: true,
    patient: null,
    sessionName: "",
    patientsSearch: "",
  });

  const updateFilter = (key, value) => {
    setFilters((prev) => ({ ...prev, [key]: value }));
  };

  const loadPatients = async (inputValue) => {
    let searchReq = new searchUsersReq();
    let types = new UserTypes();
    searchReq.name = inputValue;
    searchReq.userType = types.Patient;
    searchReq.pagingParams.pageSize = 20;

    let res = await UsersApi.SearchUsers(searchReq);
    if (res.status === "Success") {
      return res.data.list.map((item) => ({ value: item, label: item.name }));
    }
    return [];
  };

  useEffect(() => {
    let req = new CreateAccountingSessionReq();
    req.sessionId = filters.id;
    req.isPaidFor = filters.isPaidFor;
    req.isException = filters.isException;
    req.noAppointmentOnly = filters.noAppointmentOnly;
    req.patientId = filters.patient?.getPatient.id || null;
    req.sessionName = filters.sessionName;
    req.pagingParams.pageSize = 10;
    req.isAbsent = false;
    setSearchReq(req);
  }, [filters]);

  return (
    <Card sx={{ mb: 4, p: 3}}>
      <MDBox mb={2}>
        <MDTypography variant="h6" fontWeight="medium">
          Filter Sessions
        </MDTypography>
      </MDBox>

      <Grid container spacing={3} alignItems="center">
        <Grid item xs={12} md={4}>
          <AsyncSelect
            isClearable
            cacheOptions
            loadOptions={loadPatients}
            onChange={(opt) => updateFilter("patient", opt ? opt.value : null)}
            placeholder="Search Patient..."
            styles={{
              control: (base) => ({
                ...base,
                minHeight: "44px",
                borderRadius: "8px",
              }),
              menu: (base) => ({ ...base, zIndex: 999 }),
            }}
          />
        </Grid>

        {/* Session ID */}
        <Grid item xs={12} md={4}>
          <MDInput
            fullWidth
            label="Accounting Session ID"
            value={filters.id}
            onChange={(e) => updateFilter("id", e.target.value)}
          />
        </Grid>

        {/* Session Name */}
        <Grid item xs={12} md={4}>
          <MDInput
            fullWidth
            label="Session Name"
            value={filters.sessionName}
            onChange={(e) => updateFilter("sessionName", e.target.value)}
          />
        </Grid>

        {/* Checkboxes Row */}
        <Grid
          item
          xs={12}
          display="flex"
          justifyContent="space-between"
          flexWrap="wrap"
        >
          <MDBox display="flex" gap={2}>
            <FormControlLabel
              control={
                <Checkbox
                  checked={filters.isPaidFor}
                  onChange={(e) => updateFilter("isPaidFor", e.target.checked)}
                />
              }
              label={<MDTypography variant="button">Paid For</MDTypography>}
            />
            <FormControlLabel
              control={
                <Checkbox
                  checked={filters.isException}
                  onChange={(e) =>
                    updateFilter("isException", e.target.checked)
                  }
                />
              }
              label={<MDTypography variant="button">Exception</MDTypography>}
            />
            <FormControlLabel
              control={
                <Checkbox
                  checked={filters.noAppointmentOnly}
                  onChange={(e) =>
                    updateFilter("noAppointmentOnly", e.target.checked)
                  }
                />
              }
              label={
                <MDTypography variant="button">Unscheduled Only</MDTypography>
              }
            />
          </MDBox>

          <Button
            variant="outlined"
            startIcon={<Icon>search</Icon>}
            onClick={GetTableData}
            sx={{ px: 4, color: "text.primary", borderColor: "text.primary" }}
          >
            Search
          </Button>
        </Grid>
      </Grid>
    </Card>
  );
};

export default SearchSingleSessions;
